import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex w-full flex-column px-3 py-1 mt-3 mb-4" }
const _hoisted_2 = { class: "w-full mt-2" }
const _hoisted_3 = { class: "w-6 p-0" }
const _hoisted_4 = {
  key: 1,
  class: "student p-3 justify-content-center text-center"
}
const _hoisted_5 = { class: "w-6 p-0" }
const _hoisted_6 = {
  key: 1,
  class: "student p-3 justify-content-center text-center"
}

import { toRefs } from 'vue';
import { OverageListInterface } from '@/types';
import SeatsPerDisciplineHeader from './SeatsPerDisciplineHeader.vue';
import StudentInSeat from './StudentInSeat.vue';

interface Props {
  overage: OverageListInterface;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SeatsPerDiscipline',
  props: {
    overage: {}
  },
  setup(__props: any) {

const props = __props;

const { overage } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SeatsPerDisciplineHeader, { overage: _unref(overage) }, null, 8, ["overage"]),
    _createElementVNode("table", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("th", null, "Completed Students"),
          _createElementVNode("th", null, "Scheduled Students")
        ])
      ], -1)),
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_3, [
            (_unref(overage).completed_students.length)
              ? (_openBlock(), _createBlock(StudentInSeat, {
                  key: 0,
                  students: _unref(overage).completed_students
                }, null, 8, ["students"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, " No completed students for this discipline "))
          ]),
          _createElementVNode("td", _hoisted_5, [
            (_unref(overage).scheduled_students.length)
              ? (_openBlock(), _createBlock(StudentInSeat, {
                  key: 0,
                  students: _unref(overage).scheduled_students
                }, null, 8, ["students"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, " No scheduled students for this discipline "))
          ])
        ])
      ])
    ])
  ]))
}
}

})